/* eslint-disable jsx-a11y/control-has-associated-label */
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from 'aa_common/front-end/antd'
import { getNs } from 'common/i18n-config'
import React from 'react'

import { CreditHeader, DebitHeader, Grid, GridItem, SummaryHeader, TableTitle } from './styles'

const { t, useNsReady } = getNs(['components/organisms/accounting/auto-journal-setting-tab'])
const JournalItemSettingTable: React.FC<{ title: string }> = ({ title, children }) => {
  useNsReady()

  return (
    <div className="journal-item-setting-table">
      <TableTitle>{title}</TableTitle>

      <Grid>
        <DebitHeader className="grid-header">{t('debit')}</DebitHeader>
        <CreditHeader className="grid-header">{t('credit')}</CreditHeader>
        <SummaryHeader className="grid-header">
          {t('summary')}
          <Tooltip
            content={t('description_display_rules_by_create_journal_method')}
            tooltipStyles={{ display: 'inline-block', marginLeft: 5 }}
            overlayInnerStyle={{
              width: '630px',
              marginLeft: '-500px',
            }}
          >
            <FontAwesomeIcon icon={faCircleInfo} style={{ color: '#7c8291', cursor: 'pointer' }} />
          </Tooltip>
        </SummaryHeader>

        <GridItem className="section-name" />
        <GridItem className="section-name account-item">{t('account_item')} </GridItem>
        <GridItem className="section-name">{t('account_subitem')}</GridItem>
        <GridItem className="section-name" />
        <GridItem className="section-name account-item">{t('account_item')} </GridItem>
        <GridItem className="section-name account-sub-item">{t('account_subitem')}</GridItem>
        {children}
      </Grid>
    </div>
  )
}
export default JournalItemSettingTable
